import React, { useState, useEffect, useRef } from "react";
import snehal from "../Assets/Images/snehal.png";
import kunal from "../Assets/Images/kunal.png";
import kunali from "../Assets/Images/kunali.png";
import gauri from "../Assets/Images/gauri.png";
import dipali from "../Assets/Images/dipali.png";
import dummy from "../Assets/Images/dummy.png";
import pooja from "../Assets/Images/pooja.jpeg"
import kavita from "../Assets/Images/kavita.jpeg"
import abhayraj from "../Assets/Images/abhayraj.png"
import abhay from "../Assets/Images/abhay.png"
import neha from "../Assets/Images/nehaplaced.jpeg"




import { MdChevronLeft, MdChevronRight } from "react-icons/md";

const students = [
  { name: "Snehal Shirture", designation: "AWS Developer", company: "NuSummit Technology", location: "Pune", image: snehal },
  { name: "Pooja Patil", designation: "Software Engineer", company: "Accenture", location: "Pune", image: pooja },
  { name: "Kavita Chaudhari", designation: "Software Engineer", company: "Infosys", location: "Pune", image: kavita },
  { name: "Abhay Raj Sapkal", designation: "Software Developer", company: "RBIS Technologies Pvt. Ltd.", location: "Pune", image: abhayraj },
  { name: "Abhay Sonawane", designation: "Front-end Developer", company: "Lemma Technology Pvt. Ltd.", location: "Pune", image: abhay },
  { name: "Kunal Panjwani", designation: "DevOps Engineer", company: "XCaliber Infotech Pvt. Ltd.", location: "Pune", image: kunal },
  { name: "Kunali Bendale", designation: "Software Developer", company: "Code Pillar Pvt. Ltd.", location: "Indore", image: kunali },
  { name: "Neha Patil", designation: "Quality Analyst", company: "Panthernails Business Solutions", location: "Pune", image: neha },
  { name: "Amruta Kulkarni", designation: "Quality Analyst", company: "Sugamya Digital Solutions", location: "Pune", image: dummy },
  { name: "Gauri Chaudhari", designation: "Software Engineer", company: "Xcelet Technology Pvt. Ltd.", location: "Pune", image: gauri },
  { name: "Chetan Sharma", designation: "Back-end Developer", company: "Digitos IT Solutions", location: "Chatrapati Sambhaji Nagar", image: dummy },
  { name: "Dipali Shinde", designation: ".NET Developer", company: "Script Matrix", location: "Vadodara", image: dipali },
];

const PlacedStudents = () => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(4);
  const intervalRef = useRef(null);

  useEffect(() => {
    const updateVisible = () => {
      if (window.innerWidth < 640) setVisible(1);
      else if (window.innerWidth < 768) setVisible(2);
      else if (window.innerWidth < 1024) setVisible(3);
      else setVisible(4);
    };

    updateVisible();
    window.addEventListener("resize", updateVisible);
    return () => window.removeEventListener("resize", updateVisible);
  }, []);

  useEffect(() => {
    startAutoScroll();
    return stopAutoScroll;
  }, [index, visible]);

  const startAutoScroll = () => {
    stopAutoScroll();
    intervalRef.current = setInterval(() => {
      setIndex((prev) =>
        prev >= students.length - visible ? 0 : prev + 1
      );
    }, 3000);
  };

  const stopAutoScroll = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  const next = () =>
    setIndex(index >= students.length - visible ? 0 : index + 1);

  const prev = () =>
    setIndex(index === 0 ? students.length - visible : index - 1);

  return (
    <section className="bg-gradient-to-b from-gray-200 to-gray-300 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
          Our Placed Students
        </h2>

        <div
          className="relative"
          onMouseEnter={stopAutoScroll}
          onMouseLeave={startAutoScroll}
        >
          <button
            onClick={prev}
            className="absolute left-2 md:left-0 top-1/2 -translate-y-1/2 z-10
                       bg-white shadow-lg rounded-full p-2 hover:scale-110 transition"
          >
            <MdChevronLeft className="text-gray-600" size={30} />
          </button>

          <button
            onClick={next}
            className="absolute right-2 md:right-0 top-1/2 -translate-y-1/2 z-10
                       bg-white shadow-lg rounded-full p-2 hover:scale-110 transition"
          >
            <MdChevronRight className="text-gray-600" size={30} />
          </button>

          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-700 ease-in-out"
              style={{
                transform: `translateX(-${index * (100 / visible)}%)`,
              }}
            >
              {students.map((s, i) => (
                <div
                  key={i}
                  className="flex-shrink-0 px-4"
                  style={{ width: `${100 / visible}%` }}
                >
                  <div className="bg-white rounded-2xl p-6 text-center shadow-md 
                                  hover:shadow-2xl hover:-translate-y-2 
                                  transition-all duration-300">
                    <img
                      src={s.image}
                      alt={s.name}
                      className="w-20 h-20 rounded-full mx-auto mb-4 
                                 object-cover ring-4 ring-pink-200"
                    />
                    <h4 className="font-semibold text-lg text-gray-800">
                      {s.name}
                    </h4>
                    <p className="text-sm text-pink-500 font-medium">
                      {s.designation}
                    </p>
                    <p className="text-sm text-gray-500">{s.company}</p>
                    <p className="text-xs text-gray-400">{s.location}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-center mt-8 gap-2">
            {Array.from({ length: students.length - visible + 1 }).map(
              (_, i) => (
                <span
                  key={i}
                  className={`h-2 rounded-full transition-all ${i === index ? "bg-pink-500 w-5" : "bg-gray-400 w-2"
                    }`}
                />
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlacedStudents;
